/* judgeme-dashes.js - display normalizer (03-10). Judge.me reviews and shop
   replies are customer/shop data and may contain long dashes (U+2014, U+2013);
   the store copy rule is a short dash only. This replaces them with "-" in TEXT
   NODES inside Judge.me containers, via textContent (never innerHTML). The data
   in Judge.me is not changed. A MutationObserver covers widgets that render
   late. */
(function () {
  'use strict';

  var CONTAINERS =
    '.jdgm-widget, .jdgm-rev-widg, .jdgm-all-reviews-widget, .jdgm-carousel-wrapper, ' +
    '.jdgm-review-widget, .jdgm-medals-wrapper, .jdgm-preview-badge, .jdgm-rev';
  var DASHES = /[\u2013\u2014]/g;

  function normalizeText(text) {
    return typeof text === 'string' ? text.replace(DASHES, '-') : text;
  }

  function normalizeTree(node) {
    if (!node) return;
    if (node.nodeType === 3) {
      var next = normalizeText(node.textContent);
      if (next !== node.textContent) node.textContent = next;
      return;
    }
    var kids = node.childNodes;
    if (!kids) return;
    for (var i = 0; i < kids.length; i += 1) normalizeTree(kids[i]);
  }

  function inContainer(node) {
    var el = node && node.nodeType === 3 ? node.parentNode : node;
    return !!el && typeof el.closest === 'function' && !!el.closest(CONTAINERS);
  }

  function handle(mutations) {
    for (var i = 0; i < mutations.length; i += 1) {
      var m = mutations[i];
      if (m.type === 'characterData') {
        if (inContainer(m.target)) normalizeTree(m.target);
        continue;
      }
      for (var j = 0; j < m.addedNodes.length; j += 1) {
        var added = m.addedNodes[j];
        if (inContainer(added)) normalizeTree(added);
      }
    }
  }

  function start() {
    if (typeof document === 'undefined' || !document.body) return;
    var existing = document.querySelectorAll(CONTAINERS);
    for (var i = 0; i < existing.length; i += 1) normalizeTree(existing[i]);
    if (typeof MutationObserver === 'function') {
      new MutationObserver(handle).observe(document.body, {
        childList: true,
        characterData: true,
        subtree: true
      });
    }
  }

  if (typeof window !== 'undefined') {
    window.JudgemeDashes = { normalizeText: normalizeText, normalizeTree: normalizeTree };
  }
  if (typeof document !== 'undefined') {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
    else start();
  }
})();
